import config from '../config.js';

export async function invokeApig(
  { path,
    method = 'GET',
    body }, userToken) {

  const url = `${config.apiGateway.URL}${path}`;
  const headers = {
    Authorization: userToken,
  };

  body = (body) ? JSON.stringify(body) : body;

  const results = await fetch(url, {
    method,
    body,
    headers
  });

  //When user cancels the session
  // if (results.status === "cancelled") {
  //   return null;
  // }
  if (results.status !== 200) {
    const resultJSON = await results.json()
    //console.log (resultJSON);
    // const resultsBody = JSON.parse(results.body);
    var errorString = "Unknown error, HTTP code: " + results.status;
    if (resultJSON.hasOwnProperty('error')) errorString = resultJSON.error;
    throw new Error(errorString);
  }

  return results.json();
}


// WEBPACK FOOTER //
// ./src/libs/awsLib.js